import { Button, Tooltip } from 'antd';
import { groupArchiveBlockReason } from '../model/groupArchive';
import { useGroupArchive } from '../model/useGroupArchive';
import type { CategoryDto } from '../model/types';

export interface GroupArchiveButtonProps {
  group: Pick<CategoryDto, 'id' | 'name' | 'parentId' | 'isArchived'>;
  /** Весь список категорий (с архивными или без): по нему считаются живые подкатегории группы. */
  categories: Pick<CategoryDto, 'parentId' | 'isArchived'>[];
  /** После успешной отправки в архив (например, закрыть окно группы). */
  onArchived?: () => void;
  size?: 'small' | 'middle';
}

/** §2.1: «Удалить» корневую группу = «В архив». Для группы с неархивными подкатегориями кнопка
 *  недоступна, а подсказка объясняет почему; архивную группу можно вернуть. */
export function GroupArchiveButton({ group, categories, onArchived, size = 'small' }: GroupArchiveButtonProps) {
  const { archiveGroup, restoreGroup } = useGroupArchive();

  if (group.isArchived) {
    return (
      <Button size={size} onClick={() => void restoreGroup(group)}>
        Вернуть из архива
      </Button>
    );
  }

  const reason = groupArchiveBlockReason(group, categories);
  return (
    <Tooltip title={reason}>
      <Button size={size} disabled={reason !== null} onClick={() => archiveGroup(group, onArchived)}>
        В архив
      </Button>
    </Tooltip>
  );
}
